export default __webpack_public_path__ + "static/media/benjamin-moseley.9888aecf.png";